<template>
  <div style="height: 100vh">
    <div
      style="height: 100vh"
      class="d-flex justify-center align-center flex-column"
      v-if="isLoading"
    >
      <p>Carregando...</p>
      <v-progress-circular
        indeterminate
        color="primary"
        class="mb-0"
      ></v-progress-circular>
    </div>
    <section class="record">
      <v-form>
        <div>
          <div class="header-record">
            <h2
              v-if="maker === false && editable === false"
              class="primary--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"
            >
              <v-icon size="40" color="primary" class="mb-1 mr-2"
                >content_paste</v-icon
              >
              Visualização de Prontuário
            </h2>
            <h2
              v-else-if="editable"
              class="primary--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"
            >
              <v-icon size="40" color="primary" class="mb-1 mr-2"
                >content_paste</v-icon
              >
              Criação de Prontuário
            </h2>
            <h2
              v-else
              class="primary--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"
            >
              <v-icon size="40" color="primary" class="mb-1 mr-2"
                >content_paste</v-icon
              >
              Edição de Prontuário
            </h2>
            <v-btn
              v-if="maker === false && editable === false"
              type="button"
              dark
              large
              color="grey darken-2"
              @click="
                () => {
                  this.editable = true;
                  this.canEditMedicalRecord = true;
                }
              "
              >Editar Prontuário</v-btn
            >
          </div>
          <main class="content-record">
            <div>
              <h3
                class="gray--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"
              >
                Informações sobre o usuário
              </h3>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Queixa Principal
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.main_complaint"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Evolução da Queixa (Como começou/ Foi repentino ou gradual/
                  Quais transformações ocorreram os sintomas
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.evolution_complaint"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Diagnóstico Clinico
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.clinical_diagnosis"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Medicações
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.medication"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Histórico
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.history"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Profissão/<br class="d-md-none" />Escolaridade
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.profession"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Religião
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.religion"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  OUTROS (Registe aqui algo a mais que seja importante para a
                  identificação do seu paciente)
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.others"
                ></v-textarea>
              </div>
            </div>
            <div>
              <h3
                class="gray--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"
              >
                Acompanhamento Psicológico (Sessão)
              </h3>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Data
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  readonly
                  background-color="#ededed"
                  hide-details="auto"
                  v-model="form.date.split('-').reverse().join('/')"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Duração
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.duration"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Tema da Sessão
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  @input="
                    (e) => {
                      if (this.editable != true) {
                        this.$nextTick(() => {
                          this.form.session_theme = this.form.date;
                        });
                      }
                    }
                  "
                  v-model="form.session_theme"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Estado Geral do Paciente(Humor, orientação, etc)
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.general_patient_status"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Registos de Intervenções/ Orientações
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.intervention_or_guidance_records"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Alterações nas Medicações
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.changes_in_medications"
                ></v-textarea>
              </div>
              <div class="card-record-entry">
                <div
                  class="bg-lightGray d-flex align-center justify-start caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                >
                  Instrumentos Psicológicos (qual o instrumento utilizado/
                  Resultados/ Análises)
                </div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.psychological_instruments"
                ></v-textarea>
              </div>
              <h3
                class="gray--text font-weight-bold ma-0 body-1 text-lg-h5 text-left"
              >
                Outros Registros
              </h3>
              <div>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  v-if="this.editable"
                  label="Registe aqui outras informações que julgue importantes"
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.others_registers"
                ></v-textarea>
                <v-textarea
                  class="input-entrevista"
                  solo
                  flat
                  v-else
                  label=""
                  style="cursor: default"
                  height="100%"
                  background-color="#ededed"
                  hide-details="auto"
                  v-bind:readonly="this.editable === false"
                  v-model="form.others_registers"
                ></v-textarea>
              </div>
            </div>
          </main>
        </div>
      </v-form>
      <div v-if="maker" class="action-maker">
        <v-btn
          color="secondary"
          depressed
          large
          @click="enviarForm"
          :loading="isLoading"
          >FINALIZAR
        </v-btn>
      </div>
      <div class="action-put" v-if="canEditMedicalRecord">
        <v-btn
          type="button"
          color="grey lighten-4"
          depressed
          large
          @click="cancelEdit"
          :loading="isLoading"
          class="button"
          >CANCELAR
        </v-btn>
        <v-btn
          type="button"
          color="secondary"
          depressed
          large
          @click="putRecord"
          :loading="isLoading"
          class="button"
          >SALVAR
        </v-btn>
      </div>
    </section>
    <v-dialog v-model="modal" max-width="550" class="dialog-consult">
      <v-card class="dialog-consult">
        <h1>Informações de Pagamento</h1>
        <section>
          <div>
            <strong>Nome</strong>
            <span>{{ details.patient.name.toString() }}</span>
          </div>
          <div>
            <strong>Valor Cobrado</strong>
            <span>€ {{ finalValue }}</span>
          </div>
          <div>
            <strong>Data</strong>
            <span>{{ details.date | formatDate }}</span>
          </div>
          <div>
            <strong>Valor Líquido</strong>
            <span style="color: #45a655; font-weight: 600"
              >€ {{ details.stripe_payment_value }}</span
            >
          </div>
        </section>
        <footer>
          <button @click="onClose()">Cancelar</button>
          <button @click="goFinances()">Ir para a Receita</button>
        </footer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  createMedicalRecords,
  getDetails,
  getIndexMedicalRecord,
  patchMedicalRecords,
} from '../../services/psychologists';

export default {
  name: 'FormProntuario',
  data() {
    return {
      details: {
        patient: { name: '' },
        pt_value: '',
        date: '',
        stripe_payment_value: '',
      },
      medical_record: {},
      form: {
        main_complaint: '',
        evolution_complaint: '',
        clinical_diagnosis: '',
        medication: '',
        history: '',
        profession: '',
        religion: '',
        others: '',
        date: '',
        duration: '',
        session_theme: '',
        general_patient_status: '',
        intervention_or_guidance_records: '',
        changes_in_medications: '',
        psychological_instruments: '',
        others_registers: '',
      },
      isLoading: false,
      editable: false,
      maker: false,
      modal: false,
      canEditMedicalRecord: false,
      finalValue: ''
    };
  },
  async created() {
    const { idAppointment, maker, idMedicalRecord } = this.$route.params;
    if (maker) {
      this.editable = true;
    }
    if (!idAppointment) {
      this.$router.replace('/psicologo/historico-pacientes');
      this.$showSnackbar(
        'Você só pode chegar nesta tela tentando finalizar uma consulta.',
      );
    } else {
      const { data } = await getDetails(
        localStorage.getItem('user-id'),
        idAppointment,
      );
      this.details = data;
      if(this.details.br_value == 0){
        this.finalValue = this.details.pt_value - (this.details.pt_value * (this.details.coupon_value/100))
      } else {
        this.finalValue = this.details.br_value - (this.details.br_value * (this.details.coupon_value/100))
      }
      this.maker = maker;
      if (idMedicalRecord === 'created') return;
      if (idMedicalRecord) {
        const { data: index } = await getIndexMedicalRecord(idMedicalRecord);
        this.form = index;
      }
    }
  },
  methods: {
    goFinances() {
      this.$router.replace('/psicologo/financeiro');
    },
    onClose() {
      this.modal = false;
      this.$router.replace('/psicologo/dashboard');
    },
    async enviarForm() {
      this.form.date = new Date().toISOString().substr(0, 10);
      const { idAppointment } = this.$route.params;
      const res = await createMedicalRecords({
        ...this.form,
        appointment: idAppointment,
      });
      if (res) {
        this.$showSnackbar('Prontuário cadastrado com sucesso');
        this.modal = true;
      } else {
        this.$showSnackbar('Erro ao cadastrar prontuário');
      }
    },
    async cancelEdit() {
      const { idAppointment } = this.$route.params;

      this.canEditMedicalRecord = false;
      this.editable = false;
      const { data } = await getDetails(
        localStorage.getItem('user-id'),
        idAppointment,
      );
      this.details = data;
    },
    async putRecord() {
      const { idMedicalRecord } = this.$route.params;

      const pay = this.form;
      delete pay.appointment;
      delete pay.patient;

      const resp = await patchMedicalRecords(
        {
          ...pay,
        },
        idMedicalRecord,
      );
      this.editable = false;
      this.canEditMedicalRecord = false;
      if (resp) {
        this.$showSnackbar('Prontuário atualizado com sucesso');
      } else {
        this.$showSnackbar('Erro ao atulaizar prontuário');
      }
    },
  },
};
</script>

<style scoped>
* >>> .input-entrevista,
* >>> .input-entrevista.v-text-field--solo .v-input__control {
  height: 100%;
}

* >>> .v-text-field .v-label {
  max-width: 90%;
  overflow: initial;
  text-overflow: initial;
  word-break: break-word;
  top: 6px;
  white-space: unset;
  pointer-events: none;
  font-size: 0.77rem !important;
}

.dialog-consult {
  padding: 40px 20px;
  background: #ededed;
}
.dialog-consult strong {
  color: #6f6f6f;
}
.dialog-consult span {
  color: #635e5e;
  margin-top: 5px;
}
.dialog-consult section {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 50px;
}

.dialog-consult footer {
  margin-top: 35px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}

.dialog-consult button {
  padding: 4px 8px;
  border-radius: 5px;
  font-weight: 600;
}

.dialog-consult button:first-child {
  background: transparent;
  color: #635e5e;
  border: 2px solid #635e5e;
}
.dialog-consult button:last-child {
  background: #45a655;
  color: #fff;
}
.dialog-consult h1 {
  color: #45a655;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}

.dialog-consult div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 20px;
}

.action-maker {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

.action-put {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
}
.action-put button {
  display: block;
  width: 100%;
  max-width: 150px;
}
.action-put button:first-child {
  margin-right: 20px;
  text-decoration: underline;
  font-size: 12px;
}
.action-put button:last-child {
  font-size: 16px;
}
.header-record {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 0px;
}

.header-record h2 {
  font-weight: 400 !important;
  font-size: 21px;
}

.header-record button {
  width: 100% !important;
  max-width: 200px !important;
}

.content-record {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 40px;
}

.content-record h3 {
  font-weight: 500 !important;
  font-size: 18px !important;
}

.card-record-entry {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0px;
}
.card-record-entry > div:first-child {
  width: 35%;
  padding: 20px 10px;
  height: 100%;
  margin-right: 12px;
}

.record {
  width: 100%;
  max-width: 1500px;
  margin: 30px auto;
  padding: 20px;
}
@media (max-width: 1050px) {
  .content-record {
    display: block;
  }
  .card-record-entry > div:first-child {
    overflow: auto;
    height: 100%;
  }
  .content-record h3 {
    margin: 30px 10px !important;
  }
}
@media (max-width: 375px) {
  .grid-records {
    padding: 5px;
  }
}
@media (max-width: 1328px) {
  .card-record-entry > div:first-child {
    overflow: auto;
    height: 100%;
  }
}

@media (max-width: 700px) {
  .header-record {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 10px 40px 10px;
  }
  .header-record h2 {
    margin-bottom: 20px !important;
  }
  .content-record div {
    align-items: center !important;
  }
  .dialog-consult section {
    grid-column-gap: 25px;
  }
}
@media (max-width: 320px) {
  .header-record h2 {
    font-size: 16px !important;
  }
}
@media (min-width: 960px) {
  * >>> .v-text-field .v-label {
    font-size: 1rem !important;
  }
}
</style>
